import { render } from "./PacientesRelatorio.vue?vue&type=template&id=c008695a&scoped=true"
import script from "./PacientesRelatorio.vue?vue&type=script&lang=js"
export * from "./PacientesRelatorio.vue?vue&type=script&lang=js"

import "./PacientesRelatorio.vue?vue&type=style&index=0&id=c008695a&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c008695a"]])

export default __exports__